import { useState } from 'react';
import GroupsDashboard from './GroupsDashboard';
import GroupsKanban from './GroupsKanban';
import GroupsCalendar from './GroupsCalendar';

// Bascule entre Dashboard (vue d'ensemble), Kanban (gestion) et Calendrier (planning).
export default function GroupsPanel() {
  const [view, setView] = useState('dashboard');

  return (
    <div>
      <div className="admin-tabs admin-subtabs">
        <button
          className={view === 'dashboard' ? 'admin-tab active' : 'admin-tab'}
          onClick={() => setView('dashboard')}
        >
          📊 Dashboard
        </button>
        <button
          className={view === 'kanban' ? 'admin-tab active' : 'admin-tab'}
          onClick={() => setView('kanban')}
        >
          🗂️ Kanban
        </button>
        <button
          className={view === 'calendar' ? 'admin-tab active' : 'admin-tab'}
          onClick={() => setView('calendar')}
        >
          📅 Calendrier
        </button>
      </div>

     
      {view === 'kanban' && <GroupsKanban />}
       {view === 'dashboard' && <GroupsDashboard />}
      {view === 'calendar' && <GroupsCalendar />}
    </div>
  );
}